import usePageMeta from '@/hooks/usePageMeta';
import Header from '../../components/feature/Header';
import Hero from './components/Hero';
import AiDevelopment from './components/AiDevelopment';
import WhyChooseUs from './components/WhyChooseUs';
import Philosophy from './components/Philosophy';
import BusinessServices from './components/BusinessServices';
import Recruitment from './components/Recruitment';
import Footer from '../../components/feature/Footer';

const Home = () => {
  usePageMeta({
    title: 'ホーム | 株式会社MSK',
    ogTitle: 'ホーム | 株式会社MSK',
    description: '株式会社MSKは東京品川区を拠点に、システムエンジニアリングサービス・受託開発を提供。人に必要とされる人を創る企業です。',
  });

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      <main>
        <Hero />
        <AiDevelopment />
        <WhyChooseUs />
        <Philosophy />
        <BusinessServices />
        <Recruitment />
      </main>
      <Footer />
    </div>
  );
};

export default Home;